<template>
  <div class="marketingWeb"
       v-loading="fullscreenLoading">

    <!-- 弹出层 -->
    <div class="pop">

      <el-dialog title="上传图片"
                 :visible.sync="isShowUpload">
        <div class="uploadImgView">
          <el-form :model="aboutUs_image_active_data"
                   ref="aboutUs_image_active_data"
                   label-position="top"
                   class="dynamic">
            <el-form-item prop="thumb"
                          label-width="0px"
                          :rules="[
      { required: true, message: '请上传图片'},
    ]">
              <el-upload class="avatar-uploader"
                         :data='{name:columnId}'
                         :action="upUrl"
                         :show-file-list="false"
                         :on-success="aboutUsImage_fun"
                         :before-upload="beforeAvatarUpload">
                <img v-if="aboutUs_image_active_data.thumb"
                     :src="aboutUs_image_active_data.thumb"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item class="outherInfo"
                          prop="title"
                          label="请输入图片标题"
                          :rules="[
      { required: true, message: '请输入标题'},
    ]">
              <el-input v-model="aboutUs_image_active_data.title"
                        size="mini"
                        style="width:300px"
                        placeholder="请输入内容"></el-input>

            </el-form-item>

          </el-form>

        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowUpload = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('aboutUs_image_active_data', aboutUs_image_active_data, columnId, upType, () => {isShowUpload=false;getAdInfo(upType,dataName) }, true, true)">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 添加联系方式 -->
      <el-dialog title="联系人信息"
                 :visible.sync="isShowEditImage"
                 width="800px"
                 :before-close="handleClose">
        <!-- <span>{{index_wechat_cat}}</span> -->
        <div>
          <el-form :model="product_ad_data"
                   label-position="top"
                   ref="product_ad_data"
                   label-width="100px">

            <el-form-item label="产品列表广告图:"
                          prop="thumb"
                          :rules="[
      { required: true, message: '产品列表广告图不能为空'}
    ]">
              <el-upload class="avatar-uploader"
                         :action='upUrl'
                         :data='{name:"41014"}'
                         :show-file-list="false"
                         :on-success="offerSuccess"
                         :before-upload="beforeAvatarUpload">
                <img v-if="product_ad_data.thumb"
                     :src="product_ad_data.thumb"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="跳转链接:">
              <el-input v-model="product_ad_data.linkurl"
                        placeholder="请输入跳转链接"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowEditImage = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('product_ad_data',product_ad_data,product_ad_column.id,16,()=>{isShowEditImage=false 
                     collapse_change('aboutUsList')})">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加联系方式 -->
      <el-dialog title="联系人信息"
                 :visible.sync="isShowContactWay"
                 width="800px"
                 :before-close="handleClose">
        <!-- <span>{{index_wechat_cat}}</span> -->
        <div>
          <el-form :model="active_aboutUs_list_data"
                   label-position="top"
                   ref="active_aboutUs_list_data"
                   label-width="100px">

            <el-form-item label="联系人二维码图片:"
                          prop="thumb"
                          :rules="[
      { required: true, message: '联系人二维码图片不能为空'}
    ]">
              <el-upload class="avatar-uploader"
                         :action='upUrl'
                         :data='{name:"41001"}'
                         :show-file-list="false"
                         :on-success="contactWayUploadSuccess"
                         :before-upload="beforeAvatarUpload">
                <img v-if="active_aboutUs_list_data.thumb"
                     :src="active_aboutUs_list_data.thumb"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="联系人姓名:"
                          prop="title"
                          :rules="[
      { required: true, message: '联系人姓名不能为空'}
    ]">
              <el-input v-model="active_aboutUs_list_data.title"
                        placeholder="请输入联系人姓名"></el-input>
            </el-form-item>

            <el-form-item label="联系人电话(多个以 | 隔开,最多两个):"
                          prop="code"
                          :rules="[
      { required: true, message: '联系人电话不能为空'}
    ]">
              <el-input v-model="active_aboutUs_list_data.code"
                        placeholder="请输入联系人电话"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowContactWay = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('active_aboutUs_list_data',active_aboutUs_list_data,aboutUs_list_column.id,13,()=>{isShowContactWay=false 
                     collapse_change('aboutUsList')})">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 编辑公司简介底部 -->
      <el-dialog title="编辑底部公司介绍"
                 :visible.sync="isShowIntroduce_bottom"
                 width="700px"
                 :before-close="handleClose">
        <div class="editCompanyInfo">
          <el-form :model="aboutUs_bottom_synopsis_data"
                   ref="aboutUs_bottom_synopsis_data"
                   label-width="100px"
                   label-position="top"
                   class="demo-ruleForm">
            <el-form-item label="公司简介内容"
                          prop="code"
                          :rules="[
      { required: true, message: '公司简介内容不能为空'},
    ]">
              <el-input type="textarea"
                        maxlength="500"
                        placeholder="请输入公司简介内容"
                        v-model="aboutUs_bottom_synopsis_data.code">
              </el-input>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowIntroduce_bottom = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('aboutUs_bottom_synopsis_data',aboutUs_bottom_synopsis_data,aboutUs_bottom_synopsis_column.id,15,()=>{isShowIntroduce_bottom=false})">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 编辑公司简介 -->
      <el-dialog title=""
                 :visible.sync="isShowIntroduce"
                 width="1000px"
                 class="aboutUsDialog"
                 :before-close="handleClose">
        <div class="editCompanyInfo">
          <!-- <el-form :model="aboutUs_synopsis_data"
                   ref="aboutUs_synopsis_data"
                   label-width="100px"
                   label-position="top"
                   class="demo-ruleForm">
            <el-form-item label="公司简介内容"
                          prop="code"
                          :rules="[
      { required: true, message: '公司简介内容不能为空'},
    ]">
              <el-input type="textarea"
                        maxlength="500"
                        placeholder="请输入公司简介内容"
                        v-model="aboutUs_synopsis_data.code">
              </el-input>
            </el-form-item>
          </el-form> -->
          <quill-editor v-model="editorData.code"
                        class="aboutUs-quill"
                        :options="aboutUsOption"
                        ref="myQuillEditor"> </quill-editor>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowIntroduce = false"
                     size="mini">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('',editorData,editorId,editorType,)"
                     size="mini">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 模块参考 -->
      <el-dialog title="参考"
                 :visible.sync="isShowReference"
                 width="700px"
                 :before-close="handleClose">
        <div class="information_view_reference">
          <el-image :src="referenceImage"
                    :preview-src-list="[referenceImage]"
                    fit='scale-down'></el-image>
        </div>
      </el-dialog>

      <!-- 编辑栏目 -->
      <el-dialog title="编辑导航"
                 :visible.sync="isShowEditNav"
                 width="700px"
                 :before-close="handleClose">
        <div class="addNav_view"
             style='
                    height:auto'>
          <div class="addNav_view_info">
            <el-form :model="columnData"
                     ref="columnData"
                     label-width="100px"
                     label-position='top'
                     class="demo-ruleForm">

              <el-form-item label="导航名称:"
                            prop="name"
                            :rules="[
      { required: true, message: '导航名称不能为空'},
    ]">
                <el-input v-model="columnData.name"
                          placeholder="请输入导航的名称"></el-input>

              </el-form-item>

              <el-form-item label="排序值(越大越靠前):"
                            prop="displayorder"
                            :rules="[
      { required: true, message: '导航排序值不能为空'},
    ]">
                <el-input-number v-model="columnData.displayorder"
                                 :min="1"
                                 :max="255"
                                 size="mini"></el-input-number>
              </el-form-item>

            </el-form>

            <div class="addNav_view_btn">
              <el-button size="small"
                         @click="saverNav"
                         type="primary">保存</el-button>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 添加导航 -->
      <el-dialog title="添加导航"
                 :visible.sync="isShowAddNav"
                 width="1000px"
                 :before-close="handleClose">
        <div class="addNav_view">
          <div class="addNav_view_img">
            <div class="image_title">参考</div>
            <div class="imageView">
              <el-image style="width: 100%; height: 100%"
                        :src='image_url'
                        :preview-src-list="[image_url]"
                        fit='contain'></el-image>
            </div>
          </div>
          <div class="addNav_view_info">
            <el-form :model="columnData"
                     ref="columnData"
                     label-width="100px"
                     label-position='top'
                     class="demo-ruleForm">
              <el-form-item label="选择模板:"
                            prop="styleid"
                            :rules="[
      { required: true, message: '模板必须选择'},
    ]">
                <el-radio-group v-model="columnData.styleid"
                                size="mini">
                  <el-radio :label="1"
                            border>产品列表模板</el-radio>
                  <el-radio :label="2"
                            border>资讯中心模板</el-radio>
                  <el-radio :label="3"
                            border>公司介绍模板</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="导航名称:"
                            prop="name"
                            :rules="[
      { required: true, message: '导航名称不能为空'},
    ]">
                <el-input v-model="columnData.name"
                          placeholder="请输入导航的名称"></el-input>

              </el-form-item>

              <el-form-item label="排序值(越大越靠前):"
                            prop="displayorder"
                            :rules="[
      { required: true, message: '导航排序值不能为空'},
    ]">
                <el-input-number v-model="columnData.displayorder"
                                 :min="1"
                                 :max="255"
                                 size="mini"></el-input-number>

              </el-form-item>

            </el-form>

            <div class="addNav_view_btn">
              <el-button size="small"
                         @click="saverNav"
                         type="primary">保存</el-button>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 编辑轮播图 -->
      <slideAdmin :index_carousel='index_carousel'
                  ref='slideAdmini'
                  @collapse_change='collapse_change'
                  :editCarouselShow='editCarouselShow'>
      </slideAdmin>

      <!-- 微信卡片信息管理 -->
      <el-dialog title="卡片信息"
                 :visible.sync="isEditWeChatShow"
                 width="800px"
                 :before-close="handleClose">
        <!-- <span>{{index_wechat_cat}}</span> -->
        <div>
          <el-form :model="index_wechat_cat"
                   label-position="top"
                   ref="index_wechat_cat"
                   label-width="100px">

            <el-form-item label="二维码图片:"
                          prop="thumb"
                          :rules="[
      { required: true, message: '卡片二维码图片不能为空'}
    ]">
              <el-upload class="avatar-uploader"
                         :action='upUrl'
                         :data='{name:"11001"}'
                         :show-file-list="false"
                         :on-success="wechatUploadSuccess"
                         :before-upload="beforeAvatarUpload">
                <img v-if="index_wechat_cat.thumb"
                     :src="index_wechat_cat.thumb"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="卡片标题:"
                          prop="title"
                          :rules="[
      { required: true, message: '卡片标题不能为空'}
    ]">
              <el-input v-model="index_wechat_cat.title"
                        placeholder="请输入卡片的标题"></el-input>
            </el-form-item>

            <el-form-item label="卡片描述:"
                          prop="code"
                          :rules="[
      { required: true, message: '卡片描述不能为空'}
    ]">
              <el-input v-model="index_wechat_cat.code"
                        placeholder="请输入卡片的内容信息"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isEditWeChatShow = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('index_wechat_cat',index_wechat_cat,index_wechat_column.id,2,()=>{isEditWeChatShow=false})">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 选择文章添加 -->
      <articleSelect :data='isShowSelectArticle'
                     :cid='selectArticle_column_id'
                     :mid='websiteInfo.id'
                     :selectNum='maxNum'
                     :tagid='selectArticle_tagid'
                     @addEndFun="addEndFun">
      </articleSelect>

      <!-- 首页搜索宣传语 -->
      <el-dialog title="搜索宣传"
                 :visible.sync="isShowPublicityText"
                 width="800px"
                 :before-close="handleClose">
        <el-form :model="index_publicity_text"
                 label-position="top"
                 ref="index_publicity_text"
                 label-width="100px">
          <el-form-item label="卡片标题:"
                        prop="title"
                        :rules="[
      { required: true, message: '卡片标题不能为空'}
    ]">
            <el-input v-model="index_publicity_text.title"
                      maxlength="8"
                      placeholder="请输入宣传的标题"></el-input>
          </el-form-item>

          <el-form-item label="卡片描述:"
                        prop="code"
                        maxlength="20"
                        :rules="[
      { required: true, message: '卡片描述不能为空'}
    ]">
            <quill-editor v-model="index_publicity_text.code"
                          class="ql-editor"
                          :options="editorOption"
                          ref="myQuillEditor"> </quill-editor>
            <!-- <el-input v-model="index_publicity_text.code"
                      placeholder="请输入宣传的内容信息"></el-input> -->
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowPublicityText = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('index_publicity_text',index_publicity_text,index_publicity_column.id,4,()=>{isShowPublicityText=false})
                     ">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加问答 -->
      <el-dialog title="问答管理"
                 :visible.sync="isShowQA"
                 width="800px"
                 :before-close="handleClose">
        <el-form :model="index_qa_active_data"
                 label-position="top"
                 ref="index_qa_active_data"
                 label-width="100px">
          <el-form-item label="问题:"
                        prop="title"
                        :rules="[
      { required: true, message: '问题不能为空'}
    ]">
            <el-input v-model="index_qa_active_data.title"
                      placeholder="请输入问题信息"></el-input>
          </el-form-item>

          <el-form-item label="回答:"
                        prop="code"
                        :rules="[
      { required: true, message: '回答内容不能为空'}
    ]">
            <el-input v-model="index_qa_active_data.code"
                      placeholder="请输入回答内容"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowQA = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('index_qa_active_data',index_qa_active_data,index_qa_column.id,6,()=>{
                       isShowQA=false
                       collapse_change('qaMode')
                     })">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加问答 -->
      <el-dialog title="友情链接"
                 :visible.sync="isShowLink"
                 width="800px"
                 :before-close="handleClose">
        <el-form :model="link_active_data"
                 label-position="top"
                 ref="link_active_data"
                 label-width="100px">

          <el-form-item label="图片链接:">
            <el-upload class="avatar-uploader"
                       :action='upUrl'
                       :data='{name:"11897"}'
                       :show-file-list="false"
                       :on-success="linkUploadSuccess"
                       :before-upload="beforeAvatarUpload">
              <el-image v-if="link_active_data.thumb"
                        :src="link_active_data.thumb"
                        fit='contain'
                        class="avatar"></el-image>
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="文字标题（未上传图片的时候会使用文字链接）:">
            <el-input v-model="link_active_data.title"
                      placeholder="请输入文字链接"></el-input>
          </el-form-item>

          <el-form-item label="跳转地址"
                        prop="linkurl"
                        :rules="[
      { required: true, message: '跳转地址不能为空'}
    ]">
            <el-input v-model="link_active_data.linkurl"
                      placeholder="请输入回答内容"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="isShowLink = false">取 消</el-button>
          <el-button type="primary"
                     @click="saveAD('link_active_data',link_active_data,link_column.id,17,()=>{
                       isShowLink=false
                       collapse_change('link')
                     })">确 定</el-button>
        </span>
      </el-dialog>

    </div>

    <div class="marketingWeb_top">
      <div class="top_info">
        <el-image style="width: 200px; height: 100%"
                  :src="marketingWebData.site_info?marketingWebData.site_info.companyLogo:''"></el-image>
        <div class="marketingWeb_top_info">
          <el-descriptions class="margin-top"
                           :title="marketingWebData.site_info?marketingWebData.site_info.companyName:''"
                           :column="3"
                           size="medium"
                           border>

            <template slot="extra">
              <el-button type="primary"
                         @click="skip_modification"
                         size="small">编辑</el-button>
            </template>

            <!-- 公司微信号
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                公司微信号
              </template>
              {{marketingWebData.site_info.weCode||'未填写'}}
            </el-descriptions-item> -->

            <!-- 手机号 -->
            <el-descriptions-item :span="2">
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                公司电话
              </template>
              {{marketingWebData.site_info.contactNumber||'未填写'}}
            </el-descriptions-item>

            <!-- 公司地址 -->
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                公司地址
              </template>
              {{marketingWebData.site_info.companySite||'未填写'}}
            </el-descriptions-item>

            <!-- 公司域名 -->
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                公司域名
              </template>
              {{marketingWebData.bindhost}}
            </el-descriptions-item>

            <!-- 备案号 -->
            <el-descriptions-item :span="2">
              <template slot="label">
                <i class="el-icon-office-building"></i>
                域名备案号
              </template>
              {{marketingWebData.site_info.records}}
            </el-descriptions-item>

            <!-- 搜索关键词 -->
            <el-descriptions-item :span="3"
                                  label="搜索关键词">
              <template v-if="marketingWebData.site_info.seoData">
                <el-tag size="mini"
                        v-for="(item,index) in marketingWebData.site_info.seoData"
                        :key='index'>{{item}}</el-tag>
              </template>
              <template v-else>
                未填写
              </template>
            </el-descriptions-item>

          </el-descriptions>
        </div>
      </div>
      <div class="top_control">
        <el-button type="primary"
                   @click="skipArticleAdmini"
                   size="small">文章管理</el-button>
        <el-button type="success"
                   @click="showAddNavigation({})"
                   size="small">添加导航</el-button>
      </div>
    </div>

    <div class="marketingWeb_bottom">
      <el-tabs v-model="activeColumn"
               @tab-click="navigation_table">
        <el-tab-pane label="首页"
                     name="index">
        </el-tab-pane>
        <el-tab-pane :label="item.name"
                     v-for="(item,index) in columnList"
                     :key="index"
                     :name="item.id">
        </el-tab-pane>

      </el-tabs>

      <div class="marketingWeb_bottom_main">
        <!-- 首页数据 -->
        <el-collapse v-model="activeNames"
                     accordion
                     @change='collapse_change'
                     v-if="activeColumn=='index'">

          <el-collapse-item title="首页轮播图图片"
                            name="carousel">
            <div class="carousel_view">
              <el-carousel height="200px"
                           :interval="3000">
                <el-carousel-item v-for="item in index_carousel"
                                  :key="item.id">
                  <a :href="item.linkurl||false">
                    <el-image style="width: 100%; height: 100%"
                              :src="item.thumb"
                              fit="cover"></el-image>
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="control_button">
              <el-button type="primary"
                         @click="editCarouselShow.show=true"
                         size="mini">编辑</el-button>
            </div>
          </el-collapse-item>

          <el-collapse-item title="首页微信卡片"
                            name="information">
            <template v-if="index_wechat_activate!=''">
              <div class="card_view">
                <el-image :src='marketingWebData.site_info.companyLogo_2'
                          style="width: 100px;"></el-image>
                <div class="card_view_title">
                  <div class="title_top">{{index_wechat_cat.title||'扫码关注客服微信，解答疑惑。'}}</div>
                  <div class="title_bottom">{{index_wechat_cat.code||'随时随地咨询报价，关注最新价格波动，专人对接解答疑惑。'}}</div>
                </div>
                <el-image :src='index_wechat_cat.thumb'
                          style="width: 100px; height: 100px"></el-image>
              </div>

              <div class="control_button">
                <el-button type="primary"
                           @click="isEditWeChatShow=true"
                           size="mini">编辑</el-button>
              </div>

              <div class="reference_view">
                <div class="reference_view_title">参考</div>
                <el-image style=" height: 100px"
                          :src="require('../../assets/images/weChat_image.png')"></el-image>
              </div>
            </template>
            <template v-else>
              <div class="mode_nonactivated"
                   @click="prepareActivate(2)">
                <el-empty description="模块未激活，点击激活。"></el-empty>
              </div>
            </template>
          </el-collapse-item>

          <el-collapse-item title="首页产品文章列表"
                            name="productList">
            <div class="nullData"
                 v-if="!index_product_column.id">
              <div class="mode_nonactivated"
                   @click="prepareActivate(3)">
                <el-empty description="模块未激活，点击激活。"></el-empty>
              </div>
            </div>
            <div v-else
                 class="product_list">
              <div class="product_list_btn">
                <el-button type="success"
                           @click="clickShowArticle(index_product_column.id,8 - index_product_list.length,index_product_tag.id,1)"
                           :disabled='index_product_list.length>=8'
                           size="small">添加文章</el-button>
              </div>
              <el-table :data="index_product_list"
                        style="width: 100%">
                <el-table-column label="封面图片"
                                 width="130">
                  <template slot-scope="scope">
                    <el-image style="width: 100px; height: 100px"
                              :src="scope.row.thumb"
                              :preview-src-list="[scope.row.thumb]"
                              fit="fit"></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="创建日期"
                                 sortable
                                 prop="createtime"
                                 width="160">
                  <template slot-scope="scope">
                    {{common.formatDate(scope.row.createtime)}}
                  </template>
                </el-table-column>
                <el-table-column prop="click"
                                 sortable
                                 label="阅读次数"
                                 width="100">
                </el-table-column>

                <el-table-column prop="title"
                                 label="文章标题"
                                 show-overflow-tooltip
                                 width="180">
                </el-table-column>
                <el-table-column prop="description"
                                 show-overflow-tooltip
                                 label="文章描述">
                </el-table-column>
                <el-table-column label="文章控制"
                                 align="right"
                                 width="250">
                  <template slot-scope="scope">
                    <el-button size='mini'
                               @click="skipEditArticle(scope.row.id)"
                               type="primary">编辑</el-button>
                    <el-button size='mini'
                               @click="removeArticle(scope.row.id,index_product_tag.id,(res)=>{
                                      index_product_list=res.article
                               })"
                               type="danger">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>

          <el-collapse-item title="首页搜索宣传语"
                            name="publicityText">
            <template v-if="index_publicity_column.id">
              <div class="publicity_text_view">
                <div class="publicity_text_view_top">
                  <div class="top_info">
                    <div class="publicity_text_title">{{index_publicity_text.title||'团运国际'}}</div>
                    <div class="publicity_text_describe">{{index_publicity_text.code||'一起运才便宜，国际物流选团运'}}</div>
                  </div>
                  <div class="top_btn">
                    <el-button size="mini"
                               @click="isShowPublicityText=true"
                               type="primary">编辑</el-button>
                  </div>
                </div>
                <div class="publicity_text_view_bottom">
                  <div style="color:#999">参考</div>
                  <div>
                    <el-image style="width: 100%; height: 100px"
                              :src="require('../../assets/images/publicity_text.png')"
                              fit='cover'></el-image>
                  </div>
                </div>
              </div>

            </template>
            <template v-else>
              <div class="mode_nonactivated"
                   @click="prepareActivate(4)">
                <el-empty description="模块未激活，点击激活。"></el-empty>
              </div>
            </template>
          </el-collapse-item>

          <el-collapse-item title="首页头条资讯"
                            name="homePageHeadline">
            <template v-if="index_headline_column.id">
              <div class="homePageHeadline_view">
                <div class="view_top">
                  <el-button type="success"
                             @click="clickShowArticle(index_headline_column.id, 3 - index_headline_data.length,index_headline_tag.id,2)"
                             :disabled='index_headline_data.length>=3'
                             size="small">添加文章</el-button>
                </div>
                <div class="view_main">
                  <el-table :data="index_headline_data"
                            style="width: 100%">
                    <el-table-column label="封面图片"
                                     width="130">
                      <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px"
                                  :src="scope.row.thumb"
                                  :preview-src-list="[scope.row.thumb]"
                                  fit="fit"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="创建日期"
                                     sortable
                                     prop="createtime"
                                     width="160">
                      <template slot-scope="scope">
                        {{common.formatDate(scope.row.createtime)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="click"
                                     sortable
                                     label="阅读次数"
                                     width="100">
                    </el-table-column>

                    <el-table-column prop="title"
                                     label="文章标题"
                                     show-overflow-tooltip
                                     width="180">
                    </el-table-column>
                    <el-table-column prop="description"
                                     show-overflow-tooltip
                                     label="文章描述">
                    </el-table-column>
                    <el-table-column label="文章控制"
                                     align="right"
                                     width="250">
                      <template slot-scope="scope">
                        <el-button size='mini'
                                   @click="skipEditArticle(scope.row.id)"
                                   type="primary">编辑</el-button>
                        <el-button size='mini'
                                   @click="removeArticle(scope.row.id,index_headline_tag.id,(res)=>{
                                     index_headline_data=res.article
                                   })"
                                   type="danger">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="mode_nonactivated"
                   @click="prepareActivate(5)">
                <el-empty description="模块未激活，点击激活。"></el-empty>
              </div>
            </template>
          </el-collapse-item>

          <el-collapse-item title="首页问答功能"
                            name="qaMode">
            <template v-if="index_qa_column.id">
              <div class="qaData_view">
                <div class="qaData_view_top">
                  <el-button type="success"
                             @click="showAddQAInfo({})"
                             size="small">添加问答</el-button>
                </div>
                <div class="qaData_view_bottom">
                  <el-table :data="index_qa_data"
                            style="width: 100%">

                    <el-table-column prop="title"
                                     label="问题"
                                     show-overflow-tooltip
                                     width="300">

                    </el-table-column>
                    <el-table-column prop="code"
                                     label="回答"
                                     show-overflow-tooltip
                                     width="300">
                    </el-table-column>
                    <el-table-column align="right"
                                     label="操作">
                      <template slot-scope="scope">
                        <el-button size='mini'
                                   @click="showAddQAInfo(scope.row)"
                                   type="primary">编辑</el-button>
                        <el-button size='mini'
                                   @click="removeAD(scope.row.id,()=>{collapse_change('qaMode')})"
                                   type="danger">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="mode_nonactivated"
                   @click="prepareActivate(6)">
                <el-empty description="模块未激活，点击激活。"></el-empty>
              </div>
            </template>
          </el-collapse-item>

          <el-collapse-item :title="link_column.name||'友情链接'"
                            name="link">
            <template v-if="link_column.id">
              <div class="qaData_view">
                <div class="qaData_view_top">
                  <el-button @click="updataModeNmae(link_column)"
                             size="small">设置栏目名</el-button>
                  <el-button type="success"
                             @click="showAddLink({})"
                             size="small">添加友情链接</el-button>
                </div>
                <div class="qaData_view_bottom">
                  <el-table :data="link_data"
                            style="width: 100%">

                    <el-table-column label="图片链接"
                                     show-overflow-tooltip
                                     width="300">
                      <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px"
                                  fit='contain'
                                  v-if="scope.row.thumb!='nulldata'"
                                  :src="scope.row.thumb"></el-image>
                        <div v-else> 未上传 </div>
                      </template>
                    </el-table-column>

                    <el-table-column prop="title"
                                     label="文字链接"
                                     show-overflow-tooltip
                                     width="300">
                      <template slot-scope="scope">
                        <div v-if="scope.row.title!='nulldata'">{{scope.row.title}}</div>
                        <div v-else>未填写</div>
                      </template>
                    </el-table-column>

                    <el-table-column prop="linkurl"
                                     label="跳转地址"
                                     show-overflow-tooltip
                                     width="300">
                    </el-table-column>
                    <el-table-column align="right"
                                     label="操作">
                      <template slot-scope="scope">
                        <el-button size='mini'
                                   @click="showAddLink(scope.row)"
                                   type="primary">编辑</el-button>
                        <el-button size='mini'
                                   @click="removeAD(scope.row.id,()=>{collapse_change('link')})"
                                   type="danger">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

            </template>
            <template v-else>
              <div class="mode_nonactivated"
                   @click="prepareActivate(17)">
                <el-empty description="模块未激活，点击激活。"></el-empty>
              </div>
            </template>
          </el-collapse-item>

        </el-collapse>

        <!-- 产品列表数据 -->
        <div class="product_column_view"
             :key='activerNav.id'
             v-if="activerNav.styleid==1">
          <div class="column_btn">
            <el-button type="primary"
                       @click="editColumn"
                       size="small">编辑栏目</el-button>
            <el-button type="danger"
                       @click="removerColumn"
                       size="small">删除栏目</el-button>
          </div>
          <div class="column_view">
            <el-collapse v-model="activeNames"
                         accordion
                         @change="collapse_change">

              <el-collapse-item title="广告图"
                                name="adImage">
                <div v-if="!product_ad_column.id"
                     class="nullData">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(16,activerNav.id,'',16)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="adImage_view">
                  <el-image style="width: 500px; height: 300px;margin-bottom:20px"
                            :src="product_ad_data.thumb"></el-image>
                  <div>
                    <el-button type="primary"
                               @click="isShowEditImage=true"
                               size="mini">编辑</el-button>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item title="产品文章列表"
                                name="productArticles">
                <div class="nullData"
                     v-if="!product_list_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(7,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="productArticles_list">
                  <div class="productArticles_btn">

                    <el-button type="success"
                               @click="clickShowArticle(product_list_column.id, 90,product_list_tag.id,3)"
                               size="small">添加文章</el-button>
                  </div>
                  <div class="productArticles_view">
                    <el-table :data="product_list_data"
                              style="width: 100%">
                      <el-table-column label="封面图片"
                                       width="130">
                        <template slot-scope="scope">
                          <el-image style="width: 100px; height: 100px"
                                    :src="scope.row.thumb"
                                    :preview-src-list="[scope.row.thumb]"
                                    fit="fit"></el-image>
                        </template>
                      </el-table-column>
                      <el-table-column label="创建日期"
                                       sortable
                                       prop="createtime"
                                       width="160">
                        <template slot-scope="scope">
                          {{common.formatDate(scope.row.createtime)}}
                        </template>
                      </el-table-column>
                      <el-table-column prop="click"
                                       sortable
                                       label="阅读次数"
                                       width="100">
                      </el-table-column>
                      <el-table-column prop="title"
                                       label="文章标题"
                                       show-overflow-tooltip
                                       width="180">
                      </el-table-column>
                      <el-table-column prop="description"
                                       show-overflow-tooltip
                                       label="文章描述">
                      </el-table-column>
                      <el-table-column label="文章控制"
                                       align="right"
                                       width="250">
                        <template slot-scope="scope">
                          <el-button size='mini'
                                     @click="skipEditArticle(scope.row.id)"
                                     type="primary">编辑</el-button>
                          <el-button size='mini'
                                     @click="removeArticle(scope.row.id,product_list_tag.id,(res)=>{
                                      index_product_list=res.article
                               })"
                                     type="danger">移除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-collapse-item>

            </el-collapse>
          </div>
        </div>

        <!-- 资讯中心模块 -->
        <div class="information_column_view"
             v-if="activerNav.styleid==2">
          <div class="column_btn">
            <el-button type="primary"
                       @click="editColumn"
                       size="small">编辑栏目</el-button>
            <el-button type="danger"
                       @click="removerColumn"
                       size="small">删除栏目</el-button>
          </div>
          <div class="column_view">
            <el-collapse v-model="activeNames"
                         accordion
                         @change="collapse_change">
              <el-collapse-item title="资讯文章轮播图"
                                name="information_slideshow">
                <div class="nullData"
                     v-if="!information_slideshow_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(8,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="information_view">

                  <div class="information_view_main">
                    <div class="productArticles_btn">
                      <el-button size="small"
                                 @click="showReference(1)">
                        显示参考图
                      </el-button>
                      <el-button type="success"
                                 @click="clickShowArticle(information_slideshow_column.id, 5-information_slideshow_data.length,information_slideshow_tag.id,4)"
                                 :disabled='information_slideshow_data.length>=5'
                                 size="small">添加文章</el-button>
                    </div>
                    <div class="productArticles_view">
                      <el-table :data="information_slideshow_data"
                                style="width: 100%">
                        <el-table-column label="封面图片"
                                         width="130">
                          <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px"
                                      :src="scope.row.thumb"
                                      :preview-src-list="[scope.row.thumb]"
                                      fit="fit"></el-image>
                          </template>
                        </el-table-column>
                        <el-table-column label="创建日期"
                                         sortable
                                         prop="createtime"
                                         width="160">
                          <template slot-scope="scope">
                            {{common.formatDate(scope.row.createtime)}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="click"
                                         sortable
                                         label="阅读次数"
                                         width="100">
                        </el-table-column>
                        <el-table-column prop="title"
                                         label="文章标题"
                                         show-overflow-tooltip
                                         width="180">
                        </el-table-column>
                        <el-table-column prop="description"
                                         show-overflow-tooltip
                                         label="文章描述">
                        </el-table-column>
                        <el-table-column label="文章控制"
                                         align="right"
                                         width="250">
                          <template slot-scope="scope">
                            <el-button size='mini'
                                       @click="skipEditArticle(scope.row.id)"
                                       type="primary">编辑</el-button>
                            <el-button size='mini'
                                       @click="removeArticle(scope.row.id,information_slideshow_tag.id,(res)=>{
                                      information_slideshow_data=res.article
                               })"
                                       type="danger">移除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="封面图宣传文章"
                                name="information_cover">
                <div class="nullData"
                     v-if="!information_cover_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(9,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="information_view">

                  <div class="information_view_main">
                    <div class="productArticles_btn">
                      <el-button size="small"
                                 @click="showReference(2)">
                        显示参考图
                      </el-button>
                      <el-button type="success"
                                 @click="clickShowArticle(information_cover_column.id, 4-information_cover_data.length,information_cover_tag.id,5)"
                                 :disabled='information_cover_data.length>=4'
                                 size="small">添加文章</el-button>
                    </div>
                    <div class="productArticles_view">
                      <el-table :data="information_cover_data"
                                style="width: 100%">
                        <el-table-column label="封面图片"
                                         width="130">
                          <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px"
                                      :src="scope.row.thumb"
                                      :preview-src-list="[scope.row.thumb]"
                                      fit="fit"></el-image>
                          </template>
                        </el-table-column>
                        <el-table-column label="创建日期"
                                         sortable
                                         prop="createtime"
                                         width="160">
                          <template slot-scope="scope">
                            {{common.formatDate(scope.row.createtime)}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="click"
                                         sortable
                                         label="阅读次数"
                                         width="100">
                        </el-table-column>
                        <el-table-column prop="title"
                                         label="文章标题"
                                         show-overflow-tooltip
                                         width="180">
                        </el-table-column>
                        <el-table-column prop="description"
                                         show-overflow-tooltip
                                         label="文章描述">
                        </el-table-column>
                        <el-table-column label="文章控制"
                                         align="right"
                                         width="250">
                          <template slot-scope="scope">
                            <el-button size='mini'
                                       @click="skipEditArticle(scope.row.id)"
                                       type="primary">编辑</el-button>
                            <el-button size='mini'
                                       @click="removeArticle(scope.row.id,information_cover_tag.id,(res)=>{
                                      information_cover_data=res.article
                               })"
                                       type="danger">移除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item :title="information_list_column.name||'列表文章组'"
                                name="information_list">
                <div class="nullData"
                     v-if="!information_list_column.id">
                  <div class="mode_nonactivated"
                       @click="setModeName(10,activerNav.id) ">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="information_view">

                  <div class="information_view_main">
                    <div class="productArticles_btn">
                      <el-button size="small"
                                 @click="showReference(3)">
                        显示参考图
                      </el-button>
                      <el-button size="small"
                                 @click="updataModeNmae(information_list_column,information_list_tag)">
                        模块名设置
                      </el-button>
                      <el-button type="success"
                                 @click="clickShowArticle(information_list_column.id, 7-information_list_data.length,information_list_tag.id,6)"
                                 :disabled='information_list_data.length>=7'
                                 size="small">添加文章</el-button>
                    </div>
                    <div class="productArticles_view">
                      <el-table :data="information_list_data"
                                style="width: 100%">
                        <el-table-column label="封面图片"
                                         width="130">
                          <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px"
                                      :src="scope.row.thumb"
                                      :preview-src-list="[scope.row.thumb]"
                                      fit="fit"></el-image>
                          </template>
                        </el-table-column>
                        <el-table-column label="创建日期"
                                         sortable
                                         prop="createtime"
                                         width="160">
                          <template slot-scope="scope">
                            {{common.formatDate(scope.row.createtime)}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="click"
                                         sortable
                                         label="阅读次数"
                                         width="100">
                        </el-table-column>
                        <el-table-column prop="title"
                                         label="文章标题"
                                         show-overflow-tooltip
                                         width="180">
                        </el-table-column>
                        <el-table-column prop="description"
                                         show-overflow-tooltip
                                         label="文章描述">
                        </el-table-column>
                        <el-table-column label="文章控制"
                                         align="right"
                                         width="250">
                          <template slot-scope="scope">
                            <el-button size='mini'
                                       @click="skipEditArticle(scope.row.id)"
                                       type="primary">编辑</el-button>
                            <el-button size='mini'
                                       @click="removeArticle(scope.row.id,information_list_tag.id,(res)=>{
                                      information_list_data=res.article
                               })"
                                       type="danger">移除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item :title="information_image_column.name||'带图文章组'"
                                name="information_image">
                <div class="nullData"
                     v-if="!information_image_column.id">
                  <div class="mode_nonactivated"
                       @click="setModeName(11,activerNav.id) ">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="information_view">

                  <div class="information_view_main">
                    <div class="productArticles_btn">
                      <el-button size="small"
                                 @click="showReference(4)">
                        显示参考图
                      </el-button>
                      <el-button size="small"
                                 @click="updataModeNmae(information_image_column,information_image_tag)">
                        模块名设置
                      </el-button>
                      <el-button type="success"
                                 @click="clickShowArticle(information_image_column.id, 6-information_image_data.length,information_image_tag.id,7)"
                                 :disabled='information_image_data.length>=6'
                                 size="small">添加文章</el-button>
                    </div>
                    <div class="productArticles_view">
                      <el-table :data="information_image_data"
                                style="width: 100%">
                        <el-table-column label="封面图片"
                                         width="130">
                          <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px"
                                      :src="scope.row.thumb"
                                      :preview-src-list="[scope.row.thumb]"
                                      fit="fit"></el-image>
                          </template>
                        </el-table-column>
                        <el-table-column label="创建日期"
                                         sortable
                                         prop="createtime"
                                         width="160">
                          <template slot-scope="scope">
                            {{common.formatDate(scope.row.createtime)}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="click"
                                         sortable
                                         label="阅读次数"
                                         width="100">
                        </el-table-column>
                        <el-table-column prop="title"
                                         label="文章标题"
                                         show-overflow-tooltip
                                         width="180">
                        </el-table-column>
                        <el-table-column prop="description"
                                         show-overflow-tooltip
                                         label="文章描述">
                        </el-table-column>
                        <el-table-column label="文章控制"
                                         align="right"
                                         width="250">
                          <template slot-scope="scope">
                            <el-button size='mini'
                                       @click="skipEditArticle(scope.row.id)"
                                       type="primary">编辑</el-button>
                            <el-button size='mini'
                                       @click="removeArticle(scope.row.id,information_image_tag.id,(res)=>{
                                      information_image_data=res.article
                               })"
                                       type="danger">移除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
              </el-collapse-item>

            </el-collapse>
          </div>
        </div>

        <!-- 关于公司 -->
        <div class="aboutUs_column_view"
             v-if="activerNav.styleid==3">
          <div class="column_btn">
            <el-button type="primary"
                       @click="editColumn"
                       size="small">编辑栏目</el-button>
            <el-button type="danger"
                       @click="removerColumn"
                       size="small">删除栏目</el-button>
          </div>
          <div class="column_view">
            <el-collapse v-model="activeNames"
                         accordion
                         @change="collapse_change">

              <el-collapse-item title="侧导航图片"
                                name="navImage">
                <div class="nullData"
                     v-if="!aboutUs_nav_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(19,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="aboutUsSynopsis_view">
                  <el-upload class="avatar-uploader"
                             :data='{name:aboutUs_nav_column.id}'
                             :action="upUrl"
                             :show-file-list="false"
                             :on-success="aboutNavUpload"
                             :before-upload="beforeAvatarUpload">
                    <img v-if="aboutUs_nav_data.thumb"
                         :src="aboutUs_nav_data.thumb"
                         class="avatar">
                    <i v-else
                       class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-collapse-item>

              <el-collapse-item title="公司简介"
                                name="aboutUsSynopsis">
                <div class="nullData"
                     v-if="!aboutUs_synopsis_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(12,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="aboutUsSynopsis_view">
                  <div class="aboutUsSynopsis_view_text"
                       v-html="aboutUs_synopsis_data.code||'请点击下方编辑添加介绍'"></div>
                  <div class="aboutUsSynopsis_view_btn">
                    <el-button type="primary"
                               @click="showEditIntroduce(aboutUs_synopsis_data,aboutUs_synopsis_column.id,12)"
                               size="mini">编辑</el-button>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item title="网点信息"
                                name="aboutUsList">
                <div class="nullData"
                     v-if="!aboutUs_list_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(13,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="aboutUsSynopsis_view">
                  <div class="aboutUsSynopsis_view_text"
                       v-html="aboutUs_list_data.code||'请点击下方编辑添加介绍'"></div>
                  <div class="aboutUsSynopsis_view_btn">
                    <el-button type="primary"
                               @click="showEditIntroduce(aboutUs_list_data,aboutUs_list_column.id,13)"
                               size="mini">编辑</el-button>
                  </div>
                </div>
                <div>
                </div>
              </el-collapse-item>

              <el-collapse-item title="公司荣誉"
                                name="aboutUsImage">
                <div class="nullData"
                     v-if="!aboutUs_image_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(14,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="aboutUsImage_view">
                  <div class="operation">
                    <el-button size="mini"
                               @click='showUploadImage("",aboutUs_image_column.id,14,"aboutUs_image_data")'
                               type="success">添加</el-button>
                  </div>
                  <el-table :data="aboutUs_image_data"
                            style="width: 100%">
                    <el-table-column prop="date"
                                     label="图片">
                      <template slot-scope="scope">
                        <el-image style="width: 60px; height: 60px"
                                  :src="scope.row.thumb"></el-image>
                      </template>
                    </el-table-column>

                    <el-table-column prop="title"
                                     width="180"
                                     label="标题">
                    </el-table-column>
                    <el-table-column width="300"
                                     label="操作">
                      <template slot-scope="scope">

                        <el-button size="mini"
                                   type="primary"
                                   @click="showUploadImage(scope.row,aboutUs_image_column.id,14,'aboutUs_image_data')">编辑</el-button>
                        <el-button size="mini"
                                   type="danger"
                                   @click='removeAD(scope.row.id,()=>{
                                     getAdInfo(14,"aboutUs_image_data",aboutUs_image_column.id)
                                   })'>删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>

                </div>
              </el-collapse-item>

              <el-collapse-item title="公司相册"
                                name="aboutUsCImage">
                <div class="nullData"
                     v-if="!aboutUs_cimage_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(18,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="aboutUsImage_view">
                  <div class="operation">
                    <el-button size="mini"
                               @click='showUploadImage("",aboutUs_cimage_column.id,18,"aboutUs_cimage_data")'
                               type="success">添加</el-button>
                  </div>
                  <el-table :data="aboutUs_cimage_data"
                            style="width: 100%">
                    <el-table-column prop="date"
                                     label="图片">
                      <template slot-scope="scope">
                        <el-image style="width: 60px; height: 60px"
                                  :src="scope.row.thumb"></el-image>
                      </template>
                    </el-table-column>

                    <el-table-column prop="title"
                                     width="180"
                                     label="标题">
                    </el-table-column>
                    <el-table-column width="300"
                                     label="操作">
                      <template slot-scope="scope">

                        <el-button size="mini"
                                   type="primary"
                                   @click="showUploadImage(scope.row,aboutUs_cimage_column.id,18,'aboutUs_cimage_data')">编辑</el-button>
                        <el-button size="mini"
                                   type="danger"
                                   @click='removeAD(scope.row.id,()=>{
                                     getAdInfo(18,"aboutUs_cimage_data",aboutUs_cimage_column.id)
                                   })'>删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- <el-upload class="avatar-uploader"
                                 :data='{name:aboutUs_image_column.id}'
                                 :action="upUrl"
                                 :show-file-list="false"
                                 :on-success="aboutUsImage_fun"
                                 :before-upload="beforeAvatarUpload">
                        <img v-if="aboutUs_image_data.thumb"
                             :src="aboutUs_image_data.thumb"
                             class="avatar">
                        <i v-else
                           class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload> -->
                </div>
              </el-collapse-item>

              <el-collapse-item title="联系我们"
                                name="aboutUsSynopsis_bottom">
                <div class="nullData"
                     v-if="!aboutUs_bottom_synopsis_column.id">
                  <div class="mode_nonactivated"
                       @click="prepareActivate(15,activerNav.id)">
                    <el-empty description="模块未激活，点击激活。"></el-empty>
                  </div>
                </div>
                <div v-else
                     class="aboutUsSynopsis_view">
                  <div class="aboutUsSynopsis_view_text"
                       v-html="aboutUs_bottom_synopsis_data.code||'请点击下方编辑添加介绍'"></div>
                  <div class="aboutUsSynopsis_view_btn">
                    <el-button type="primary"
                               @click="showEditIntroduce(aboutUs_bottom_synopsis_data,aboutUs_bottom_synopsis_column.id,15)"
                               size="mini">编辑</el-button>
                  </div>
                </div>
              </el-collapse-item>

            </el-collapse>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { quillEditor, Quill } from 'vue-quill-editor'
import { ImageExtend, QuillWatch } from "quill-image-super-solution-module";
import ImageResize from "quill-image-resize-module"; // 引用
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register("modules/imageResize", ImageResize); // 注册
import { apiGetLanternSlide, apiGetMarketing, apiGetColumn, apiSetLanternSlide, apiAddEditColumn, apiGetArticle, apiArticle, yxGetTag, yxAddTag, yxArticleTag, apiRemoveArticle, apiRemoveColumn, apiDelectLanternSlide } from '@/request/api'
import slideAdmin from '@/components/slideAdmin.vue'
import articleSelect from '@/components/articleSelect.vue'
import common from '@/assets/js/common'
import store from '@/store/index'

export default {
  data () {
    return {
      //--------------是否显示上传弹框-----------
      isShowUpload: false,
      //--------------关于公司,富文本编辑器修改的id -----------
      editorId: '',
      //--------------关于公司,富文本编辑器修改的type -----------
      editorType: '',
      //--------------富文本编辑器内容 -----------
      editorData: { code: '' },
      //--------------富文本编辑器配置——2 -----------
      aboutUsOption: {
        example: "test",
        theme: "snow",
        placeholder: "请输入内容",
        modules: {
          ImageExtend: {
            name: 'file',
            size: 2,  // 单位为M, 1M = 1024KB
            action: store.state.upUrl,
            accept: "image/jpg, image/png, image/gif, image/jpeg, image/bmp, image/x-icon",
            headers: (xhr) => {
            },
            response: (res) => {
              return res.url
            },
            sizeError: () => {
              alert("图片大小超过 2 M");
            },
            start: () => { },
            // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            // Optional parameters. Customize the event triggered by the end of upload, regardless of success or failure
            end: () => { },
            // 可选参数 上传失败触发的事件
            // Optional parameter. The event triggered by upload failure
            error: () => { },
            // 可选参数  上传成功触发的事件
            // Optional parameter. The event triggered by a successful upload
            success: () => { },
          },
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          //  富文本编辑器配置
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
              [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
              [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
              [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
              [{ align: [] }], // 对齐方式-----[{ align: [] }]
              ["image",], // 链接、图片、视频-----['link', 'image', 'video']
            ],
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      //--------------富文本编辑器配置——1 -----------
      editorOption: {
        example: "test",
        theme: "snow",
        placeholder: "请输入描述",
        modules: {

          //  富文本编辑器配置
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
              [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
              [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
              [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
              [{ align: [] }], // 对齐方式-----[{ align: [] }]
            ],
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      //--------------参考的图片 -----------
      referenceImage: require('../../assets/images/slideshow_image.png'),
      //--------------当前导航栏数据 -----------
      activerNav: {},
      //--------------栏目数据 -----------
      columnData: {
        styleid: 1
      },
      //--------------公共方法 -----------
      common,
      //--------------网站信息 -----------
      websiteInfo: '',
      //--------------是否显示选择添加文章 -----------
      isShowSelectArticle: {
        show: false
      },
      selectArticle_column_id: '',
      maxNum: 0,
      selectArticle_tagid: '',
      selectType: '',
      //--------------网络请求url -----------
      upUrl: '',
      //--------------编辑产品列表广告图 -----------
      isShowEditImage: false,
      // ---------------------添加联系方式-------------
      isShowContactWay: false,
      // ---------------------是否显示编辑公司介绍——  -------------
      isShowIntroduce_bottom: false,
      // ---------------------是否显示编辑公司介绍-------------
      isShowIntroduce: false,
      // ---------------------是否显示参考-------------
      isShowReference: false,
      // ---------------------是否显示编辑导航-------------
      isShowEditNav: false,
      // ---------------------是否显示添加导航-------------
      isShowAddNav: false,
      // ---------------------是否显示编辑添加问答-------------
      isShowQA: false,
      // ---------------------是否显示编辑/添加友情链接-------------
      isShowLink: false,
      // ---------------------是否显示编辑搜索宣传-------------
      isShowPublicityText: false,
      // ---------------------是否显示编辑微信卡片-------------
      isEditWeChatShow: false,
      // ---------------------编辑首页轮播图模块数据弹窗-选择的数据-------------
      editSelectData: {},
      // ---------------------编辑首页轮播图模块数据弹窗-选择的index-------------
      editSelectIndex: 0,
      // ---------------------编辑首页轮播图模块数据弹窗-------------
      editCarouselShow: { show: false },
      // ---------------------栏目数据-------------
      index_carousel: [],  //首页轮播图

      index_wechat_activate: '', //首页微信卡片是否激活
      index_wechat_column: {}, //微信卡片栏目数据
      index_wechat_cat: { thumb: '' }, //首页微信卡片详情数据

      index_product_column: {},//产品列表模块数据
      index_product_list: [], //首页产品列表数据
      index_product_tag: {}, //首页产品的Tag数据

      index_publicity_text: {}, //网站搜索宣传语数据
      index_publicity_column: {}, //网站搜索宣传语栏目数据

      index_headline_data: [], //首页头条资讯数据
      index_headline_column: {}, //首页头条资讯数据
      index_headline_tag: {}, //首页头条资讯Tag数据

      index_qa_data: [], //首页问答数据
      index_qa_column: {}, //首页问答栏目
      index_qa_active_data: {}, //修改/添加的问答数据

      product_ad_column: {}, //产品列表模板-产品列表栏目数据
      product_ad_data: [], //产品列表模板-产品列表栏目数据

      product_list_column: {}, //产品列表模板-产品列表栏目数据
      product_list_data: [], //产品列表模板-产品列表栏目数据
      product_list_tag: {}, //产品列表模板-产品列表栏目数据

      information_slideshow_column: {}, //资讯模板-轮播图列表栏目数据
      information_slideshow_data: [], //资讯模板-轮播图栏目数据
      information_slideshow_tag: {}, //资讯模板-轮播图栏目数据

      information_cover_column: {}, //资讯模板-封面图宣传栏目数据
      information_cover_data: [], //资讯模板-封面图宣传栏目数据
      information_cover_tag: {}, //资讯模板-封面图宣传目数据


      information_list_column: {}, //资讯模板-列表文章栏目数据
      information_list_data: [], //资讯模板-列表文章栏目数据
      information_list_tag: {}, //资讯模板-列表文章目数据

      information_image_column: {},//资讯模板-带图宣传文章栏目数据
      information_image_data: [],  //资讯模板-带图宣传文章栏目数据
      information_image_tag: {},   //资讯模板-带图宣传文章tag数据


      aboutUs_synopsis_column: {},//关于公司-公司简介栏目数据
      aboutUs_synopsis_data: { description: '' },  //关于公司-公司简介数据

      aboutUs_list_column: {},//关于公司-联系方式栏目数据
      aboutUs_list_data: [],  //关于公司-联系方式数据
      active_aboutUs_list_data: {},  //关于公司-当前编辑联系方式数据

      aboutUs_image_active_data: { thumb: '', title: '' },//关于公司-宣传图片栏目数据-修改
      aboutUs_image_column: {},//关于公司-宣传图片栏目数据
      aboutUs_image_data: [],  //关于公司-宣传图片数据

      aboutUs_cimage_column: {},//关于公司-宣传图片栏目数据
      aboutUs_cimage_data: [],  //关于公司-宣传图片数据

      aboutUs_bottom_synopsis_column: {},//关于公司-公司简介栏目数据
      aboutUs_bottom_synopsis_data: {},  //关于公司-公司简介数据

      aboutUs_nav_column: {},//侧导航图片-栏目数据
      aboutUs_nav_data: {},  //侧导航图片

      link_column: {},//友情链接-栏目数据
      link_data: {},  //友情链接-数据
      link_active_data: { linkurl: '' }, //修改/添加的友情链接数据

      // ---------------------上传图片数据-------------
      columnId: '',
      upType: '',
      dataName: '',
      // ---------------------显示弹框-------------
      dialogVisibleShow: true,
      // ---------------------选择的栏目数据-------------
      activeData: {},
      // ---------------------选择的栏目-------------
      activeNames: '',
      // ---------------------栏目列表-------------
      columnList: [],
      // ---------------------当前激活的栏目-------------
      activeColumn: 'index',
      // ---------------------公司营销网站的栏目-------------
      companyColumn: [],
      // ---------------------营销网站数据-------------
      marketingWebData: {
        site_info: {
          weCode: ''
        }
      },
      // --------------------加载动画--------------
      fullscreenLoading: false,
      // --------------------用户uid--------------
      uid: '加载中',
    }
  },

  methods: {

    //--------------获取广告图片数据-----------
    async getAdInfo (type, dataName, cid) {
      let res = await apiSetLanternSlide({
        siteid: this.websiteInfo.id,
        type,
        cid: cid || this.columnId
      })
      if (res.errno == 0) {
        this[dataName] = res.list
      }

    },
    //--------------显示关于公司上传图片弹框-----------
    showUploadImage (d, cid, type, dataName) {

      if (d) {
        for (const key in d) {
          this.aboutUs_image_active_data[key] = d[key]
        }
      } else {
        this.aboutUs_image_active_data = { thumb: '', title: '' }
        if (this.$refs.aboutUs_image_active_data) {
          this.$refs.aboutUs_image_active_data.resetFields()
        }
      }
      this.dataName = dataName
      this.columnId = cid
      this.upType = type
      this.isShowUpload = true
    },
    //--------------移除广告-----------
    removeAD (id, fun) {
      this.$confirm('确定删除此信息吗？此操作不可逆。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await apiDelectLanternSlide({
          siteid: this.websiteInfo.id,
          id
        })
        fun ? fun() : ''
        this.$message(res.message)
      })
    },
    //--------------侧导航图片上传回调-----------
    aboutNavUpload (res) {
      this.$set(this.aboutUs_nav_data, 'thumb', res.url)
      this.saveAD('', this.aboutUs_nav_data, this.aboutUs_nav_column.id, 19)
    },
    //--------------联系图片上传成功回调-----------
    aboutUsImage_fun (res) {
      this.$set(this.aboutUs_image_active_data, 'thumb', res.url)
    },
    //--------------显示联系人信息-----------
    showContactWay (row) {
      this.isShowContactWay = true
      this.active_aboutUs_list_data = row
    },
    //--------------显示编辑公司介绍-----------
    showEditIntroduce (d, id, type) {
      this.editorData = d;
      this.editorId = id;
      this.editorType = type
      this.isShowIntroduce = true;
    },
    //--------------更换模块名-----------
    updataModeNmae (column, tag) {
      this.$prompt('请输入新模块名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        column.name = value
        let res = await apiAddEditColumn({
          siteid: this.websiteInfo.id,
          ...column
        })
        if (tag) {
          // 顺便更换掉tag的名称
          await yxAddTag({
            siteid: this.websiteInfo.id,
            id: tag.id,
            name: value
          })
        }

        this.$message(res.message)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消更改'
        });
      });
    },
    //--------------设置模块名模式-----------
    setModeName (type, id) {
      this.$prompt('请输入模块名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.prepareActivate(type, id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    //--------------显示参考-----------
    showReference (type) {
      if (type == 1) {
        this.referenceImage = require('../../assets/images/slideshow_image.png')
      } else if (type == 2) {
        this.referenceImage = require('../../assets/images/information_cover.png')
      } else if (type == 3) {
        this.referenceImage = require('../../assets/images/information_list.png')
      } else if (type == 4) {
        this.referenceImage = require('../../assets/images/information_image.png')
      }



      this.isShowReference = true
    },
    //--------------添加完成回调-----------
    async addEndFun () {
      let res = await this.getArticle('', '', '', this.selectArticle_tagid, '', '', 1, 10)
      if (this.selectType == 1) {
        this.index_product_list = res.article
      } else if (this.selectType == 2) {
        this.index_headline_data = res.article
      } else if (this.selectType == 3) {
        this.product_list_data = res.article
      } else if (this.selectType == 4) {
        this.information_slideshow_data = res.article
      } else if (this.selectType == 5) {
        this.information_cover_data = res.article
      } else if (this.selectType == 6) {
        this.information_list_data = res.article
      } else if (this.selectType == 7) {
        this.information_image_data = res.article
      }
    },
    //--------------删除栏目-----------
    removerColumn () {
      this.$confirm('确定删除此栏目吗?请确定已经关闭所有子模块.', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await apiRemoveColumn({
          siteid: this.websiteInfo.id,
          id: this.activerNav.id
        })
        this.$message(res.message)
        setTimeout(() => {
          location.reload()
        }, 1000);
      })
    },
    //--------------编辑栏目数据-----------
    editColumn () {
      this.columnData = this.activerNav
      this.isShowEditNav = true
    },
    //--------------保存导航-----------
    async saverNav () {
      this.$refs.columnData.validate((valid) => {
        if (valid) {
          this.$confirm('确定已经核对完成数据了?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {

            let res = await apiAddEditColumn({
              siteid: this.websiteInfo.id,
              isnav: 1,
              ... this.columnData
            })
            this.$message(res.message)
            setTimeout(() => {
              location.reload()
            }, 1000);
          })
        } else {
          return false;
        }
      });



    },
    //--------------显示添加导航-----------
    showAddNavigation (row) {
      if (!row.styleid) {
        row.styleid = 1
      }
      this.columnData = row

      this.isShowAddNav = true
    },
    //--------------删除文章-----------
    // delectArticle (id, fun) {
    //   this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(async () => {
    //     let res = await apiRemoveArticle({
    //       siteid: this.websiteInfo.id,
    //       id
    //     })
    //     this.$message(res.message)
    //     fun ? fun() : ''
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    //--------------显示添加友情链接-----------
    showAddLink (row) {
      this.isShowLink = true
      this.link_active_data = row || { linkurl: '' }
      if (this.$refs.link_active_data) {
        this.$refs.link_active_data.resetFields()
      }
    },
    //--------------显示添加问答信息-----------
    showAddQAInfo (row) {
      this.index_qa_active_data = row
      this.isShowQA = true
      if (this.$refs.index_qa_active_data) {
        this.$refs.index_qa_active_data.resetFields()
      }
    },
    //--------------移除文章-----------
    removeArticle (id, tagid, fun) {
      this.$confirm('此操作将移除该文章，并不会删除，删除请前往文章管理。 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await yxArticleTag({
          siteid: this.websiteInfo.id,
          id,
          tagid,
          delete: 1
        })
        this.$message(res.message)
        let res_ = await this.getArticle('', '', '', tagid, '', '', 1, 10)
        fun ? fun(res_) : ''
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        });
      });
    },
    //--------------跳转编辑文章-----------
    skipEditArticle (id) {
      this.$router.push({
        name: 'article',
        query: {
          callback: location.href,
          siteid: this.websiteInfo.id,
          id
        }
      })
    },
    //--------------获取文章-----------
    async getArticle (cid, id, pid, tagid, ishot, iscommend, page, pagesize) {
      let res = await apiGetArticle({
        siteid: this.websiteInfo.id,
        cid,
        id,
        pid,
        tagid,
        ishot,
        iscommend,
        page,
        pagesize
      })
      return res
    },
    //--------------添加Tag-----------
    async addTag (type, name) {
      let res = await yxAddTag({
        siteid: this.websiteInfo.id,
        name,
        type
      })
      res = await this.getTag(type)
      return res
    },
    //--------------获取Tag-----------
    async getTag (type) {
      let res = await yxGetTag({
        siteid: this.websiteInfo.id,
        type
      })
      return res
    },
    //--------------点击选择添加文章 - 产品列表-----------
    clickShowArticle (cid, maxNum, tagid, type,) {
      this.selectArticle_column_id = cid
      this.maxNum = 99
      this.selectArticle_tagid = tagid
      this.selectType = type
      this.isShowSelectArticle.show = true
    },
    //--------------跳转文章管理-----------
    async skipArticleAdmini () {
      this.$router.push({
        name: 'ArticleAdmini',
        query: {
          m_id: this.marketingWebData.id
        }
      })
    },
    //--------------保存广告信息-----------
    saveAD (refTxt, row, cid, type, fun, noThumb, noTitle, noCode) {
      if (!row.thumb && !noThumb) {
        row.thumb = 'nulldata'
      }
      if (!row.title && !noTitle) {
        row.title = 'nulldata'
      }
      if (!row.code && !noCode) {
        row.code = 'nulldata'
      }

      if (refTxt) {
        this.$refs[refTxt].validate((valid) => {
          validate(validate, this)
        })
      } else {
        validate(true, this)
      }
      function validate (valid, than) {
        if (valid) {
          than.$confirm('确定已经核对信息了吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let res = await apiGetLanternSlide({
              siteid: than.websiteInfo.id,
              ...row,
              content: 'showNull',
              cid,
              type,
              displayorder: 1
            })
            than.$message(res.message)
            if (res.errno == 0) {
              fun ? fun() : ''
            }
          })
        } else {
          return false;
        }
      }
    },
    //--------------保存卡片信息-----------
    saveArticle (refTxt, row, cid, fun) {
      if (!row.thumb) {
        row.thumb = 'nulldata'
      }
      if (!row.title) {
        row.title = 'nulldata'
      }
      if (!row.description) {
        row.description = 'nulldata'
      }

      this.$refs[refTxt].validate((valid) => {
        if (valid) {
          this.$confirm('确定已经核对信息了吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let res = await apiArticle({
              siteid: this.websiteInfo.id,
              ...row,
              content: 'showNull',
              cid
            })
            this.$message(res.message)
            if (res.errno == 0) {
              fun ? fun() : ''
            }
          })
        } else {
          return false;
        }
      });


    },
    //--------------上传检测-----------
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // --------------------产品列表广告图上传成功回调--------------
    offerSuccess (res) {
      this.$set(this.product_ad_data, 'thumb', res.url)
    },
    // --------------------联系人信息图片上传成功回调--------------
    contactWayUploadSuccess (res) {
      this.$set(this.active_aboutUs_list_data, 'thumb', res.url)
    },
    // --------------------微信卡片图片上传成功回调--------------
    wechatUploadSuccess (res) {
      this.$set(this.index_wechat_cat, 'thumb', res.url)
    },
    // --------------------友情链接图片上传成功回调--------------
    linkUploadSuccess (res) {
      this.$set(this.link_active_data, 'thumb', res.url)
    },
    // --------------------准备激活模块--------------
    prepareActivate (type, pid, names, mode) {
      let content = ''
      let name = ''
      if (type == 2) {
        content = '确定激活卡片模块吗？'
        name = '微信卡片模块'
      } else if (type == 3) {
        content = '确定激活产品列表模块吗？'
        name = '热门产品列表模块'
      } else if (type == 4) {
        content = '确定激活首页宣传语模块吗？'
        name = '首页宣传语模块'
      } else if (type == 5) {
        content = '确定激活首页头条资讯模块吗？'
        name = '首页头条资讯模块'
      } else if (type == 6) {
        content = '确定激活问答模块吗？'
        name = '首页问答模块'
      } else if (type == 7) {
        content = '确定激活产品列表模块吗？'
        name = '产品列表模块'
      } else if (type == 8) {
        content = '确定激活资讯文章轮播图模块吗？'
        name = '文章轮播图模块'
      } else if (type == 9) {
        content = '确定激活封面图宣传文章模块吗？'
        name = '封面图宣传模块'
      } else if (type == 10 || type == 11) {
        content = '确定激活' + names + '模块吗？'
        name = names
      } else if (type == 12) {
        content = '确定激活公司简介模块吗？'
        name = '公司简介'
      } else if (type == 13) {
        content = '确定激活网点信息模块吗？'
        name = '网点信息'
      } else if (type == 14) {
        content = '确定激活联系图片模块吗？'
        name = '公司荣誉'
      } else if (type == 15) {
        content = '确定激活联系我们模块吗？'
        name = '联系我们'
      } else if (type == 16) {
        content = '确定激活产品列表广告图模块吗？'
        name = '产品列表广告图'
      } else if (type == 17) {
        content = '确定激活友情链接模块吗？'
        name = '友情链接'
      } else if (type == 18) {
        content = '确定激活公司相册模块吗？'
        name = '公司相册'
      } else if (type == 19) {
        content = '确定侧导航图片模块吗？'
        name = '侧导航图片'
      }


      this.$confirm(content, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        const res = await apiAddEditColumn({
          siteid: this.websiteInfo.id,
          type: mode || type,
          name,
          pid
        })
        this.$message(res.message)
        setTimeout(() => {
          location.reload()
        }, 1500);
      })
    },
    // ---------------------进入修改基础信息-------------
    skip_modification () {
      this.$router.push({
        name: 'websitePage',
        query: {
          type: this.marketingWebData.bindhost == '',
          type_s: 1,
          siteid: this.marketingWebData.id
        }
      })
    },
    // ---------------------关闭确认-------------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // ---------------------点击回调-------------
    async collapse_change (e) {
      if (!e) { //如果是关闭弹框就不执行
        return
      }
      let res = {}
      // 处理tag标签文章的话
      if (e == 'productList' || e == 'homePageHeadline' || e == 'productArticles' || e == 'information_slideshow' || e == 'information_cover' || e == 'information_list' || e == 'information_image') {
        let data = {}
        res = await apiGetColumn({
          siteid: this.websiteInfo.id,
          pid: e == 'productArticles' || e == 'information_slideshow' || e == 'information_cover' || e == 'information_list' || e == 'information_image' ? this.activerNav.id : '',
          type: e == 'productList' ? 3 : e == 'homePageHeadline' ? 5 : e == 'productArticles' ? 7 : e == 'information_slideshow' ? 8 : e == 'information_cover' ? 9 : e == 'information_list' ? 10 : e == 'information_image' ? 11 : '',
        })
        if (res.errno == 1) {
          // 如果不存在栏目就置空栏目数据
          if (e == 'productList') {
            this.index_product_column = {}
          } else if (e == 'homePageHeadline') {
            this.index_headline_column = {}
          } else if (e == 'productArticles') {
            this.product_list_column = {}
          } else if (e == 'information_slideshow') {
            this.information_slideshow_column = {}
          } else if (e == 'information_cover') {
            this.information_cover_column = {}
          } else if (e == 'information_list') {
            this.information_list_column = {}
          } else if (e == 'information_image') {
            this.information_image_column = {}
          }
        } else {
          // 如果存在栏目就获取标签，没有就添加一个
          data = await this.getTag(res.clist[0].id)
          if (data.errno == 0) {

          } else {
            data = await this.addTag(res.clist[0].id, e == 'productList' ? '热门产品列表' : e == 'homePageHeadline' ? '头条资讯' : e == 'productArticles' ? '产品' : e == 'information_slideshow' ? '文章轮播' : e == 'information_cover' ? '封面图宣传' : e == 'information_list' || e == 'information_image' ? res.clist[0].name : '')
          }

          let res_ = await this.getArticle('', '', '', data.list[0].id, '', '', 1, 10)

          if (e == 'productList') {
            this.index_product_list = res_.article
            this.index_product_tag = data.list[0]
            this.index_product_column = res.clist[0]
          } else if (e == 'homePageHeadline') {
            this.index_headline_data = res_.article
            this.index_headline_tag = data.list[0]
            this.index_headline_column = res.clist[0]
          } else if (e == 'productArticles') {
            this.product_list_data = res_.article
            this.product_list_tag = data.list[0]
            this.product_list_column = res.clist[0]
          } else if (e == 'information_slideshow') {
            this.information_slideshow_data = res_.article
            this.information_slideshow_tag = data.list[0]
            this.information_slideshow_column = res.clist[0]
          } else if (e == 'information_cover') {
            this.information_cover_data = res_.article
            this.information_cover_tag = data.list[0]
            this.information_cover_column = res.clist[0]
          } else if (e == 'information_list') {
            this.information_list_data = res_.article
            this.information_list_tag = data.list[0]
            this.information_list_column = res.clist[0]
          } else if (e == 'information_image') {
            this.information_image_data = res_.article
            this.information_image_tag = data.list[0]
            this.information_image_column = res.clist[0]
          }
        }

      } else {
        let type = ''
        switch (e) {
          case 'carousel':
            type = 1
            break;
          case 'information':
            type = 2
            break;
          case 'publicityText':
            type = 4
            break;
          case 'qaMode':
            type = 6
            break;
          case 'aboutUsSynopsis':
            type = 12
            break;
          case 'aboutUsList':
            type = 13
            break;
          case 'aboutUsImage':
            type = 14
            break;
          case 'aboutUsCImage':
            type = 18
            break;
          case 'aboutUsSynopsis_bottom':
            type = 15
            break;
          case 'adImage':
            type = 16
            break;
          case 'link':
            type = 17
            break;
          case 'navImage':
            type = 19
            break;
          default:
            break;
        }


        // 幻灯片不需要栏目
        if (e == 'carousel') {
          res = await apiSetLanternSlide({
            siteid: this.websiteInfo.id,
            type,
            cid: 0
          })
          this.index_carousel = res.list
          this.$refs.slideAdmini.initializeSelectData(this.index_carousel[0] || {}, this.websiteInfo)
          return
        }

        // 其他模块先获取栏目
        res = await apiGetColumn({
          siteid: this.websiteInfo.id,
          type,
          pid: this.activerNav.id,
        })
        let data = ''
        let cData = res.clist ? res.clist[0] : {}

        if (res.clist[0]) {
          // 如果栏目存在就获取广告
          data = await apiSetLanternSlide({
            siteid: this.websiteInfo.id,
            type,
            cid: res.clist[0].id,
          })

          let list = data.list ? data.list : []
          if (e == 'information') {
            this.index_wechat_column = res.clist[0]
            this.index_wechat_activate = true
            this.index_wechat_cat = list[0]
          } else if (e == 'publicityText') {
            this.index_publicity_column = cData
            this.index_publicity_text = list[0]
          } else if (e == 'qaMode') {
            this.index_qa_column = cData
            this.index_qa_data = list
          } else if (e == 'aboutUsSynopsis') {
            this.aboutUs_synopsis_column = cData
            this.aboutUs_synopsis_data = list[0] || {}
          } else if (e == 'aboutUsList') {
            this.aboutUs_list_column = cData
            this.aboutUs_list_data = list[0] || {}
          } else if (e == 'aboutUsImage') {
            this.aboutUs_image_column = cData
            this.aboutUs_image_data = list
          } else if (e == 'aboutUsCImage') {
            this.aboutUs_cimage_column = cData
            this.aboutUs_cimage_data = list
          } if (e == 'aboutUsSynopsis_bottom') {
            this.aboutUs_bottom_synopsis_column = cData
            this.aboutUs_bottom_synopsis_data = list[0] || {}
          } if (e == 'adImage') {
            this.product_ad_column = cData
            this.product_ad_data = list[0]
          } else if (e == 'link') {
            this.link_column = cData
            this.link_data = list
          } else if (e == 'navImage') {
            this.aboutUs_nav_column = cData
            this.aboutUs_nav_data = list[0] || {}
          }
        } else {
          // 不存在就清除栏目信息，因为每次只展示一个，所以可以全部清除
          this.index_wechat_activate = false
          this.index_publicity_column = {}
          this.index_qa_column = {}
          this.aboutUs_synopsis_column = {}
          this.aboutUs_list_column = {}
          this.aboutUs_image_column = {}
          this.aboutUs_bottom_synopsis_column = {}
          this.product_ad_column = {}
          this.link_column = {}
        }
      }
    },
    // ---------------------读取栏目-------------
    async getColumnData (pid, ishomepage, isnav, type, cid, page, pageSize, fun) {
      let res = await apiGetColumn({
        siteid: this.websiteInfo.id,
        pid,
        ishomepage,
        isnav,
        type,
        cid,
        page,
        pageSize
      })
      fun ? fun(res) : ''
    },
    // ---------------------获取当前栏目-------------
    navigation_table (e) {
      if (this.activeColumn == 'index') {
        return this.activerNav = {}
      }
      this.activeNames = ''

      this.getColumnData('', '', 1, '', this.activeColumn, '', '', (res) => {
        this.activerNav = res.clist[0]
      })
    },
    // ---------------------获取营销网址数据-------------
    async getWebInfo (uid, siteid, fun) {
      this.fullscreenLoading = true
      let res = await apiGetMarketing({
        uid: siteid ? '' : uid,
        siteid: siteid
      })
      this.marketingWebData = res.sitelist[0]
      fun ? fun(res) : ''
      this.websiteInfo = res.sitelist[0]
      this.fullscreenLoading = false
    },
  },
  computed: {
    image_url () {
      if (this.columnData.styleid == 1) {
        return require('../../assets/images/mode_1.png')
      } else if (this.columnData.styleid == 2) {
        return require('../../assets/images/mode_2.png')
      } else if (this.columnData.styleid == 3) {
        return require('../../assets/images/mode_3.jpg')
      }
    }
  },
  components: {
    quillEditor,
    slideAdmin,
    articleSelect
  },
  async created () {
    this.upUrl = this.$store.state.upUrl;
    this.uid = JSON.parse(localStorage.getItem("vuex")).uid
    await this.getWebInfo(this.uid, this.$route.query.siteid)
    this.getColumnData('', '', 1, '', '', '', '', (res) => {
      this.columnList = res.clist
    })

  }
}
</script>

<style lang='scss'>
.marketingWeb {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .uploadImgView {
    .dynamic {
      display: flex;
      justify-content: space-between;
    }
    .outherInfo {
      flex: 1;
      margin-left: 20px;
    }
  }
  .aboutUsImage_view {
    width: 100%;
    min-height: 400px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .operation {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .el-upload {
      width: 500px;
      height: 400px;
    }
  }
  .editCompanyInfo {
    height: 800px;
    width: 100%;
    margin-bottom: 10px;
    .aboutUs-quill {
      height: 100%;
    }
    .el-textarea {
      height: 100%;
      .el-textarea__inner {
        height: 200px;
      }
    }
  }
  .information_view_reference {
    width: 100%;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-image {
      width: 500px;
      height: 300px;
    }
  }
  .productArticles_btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .addNav_view {
    width: 100%;
    height: 700px;
    display: flex;
    .addNav_view_img,
    .addNav_view_info {
      flex: 1;
    }
    .addNav_view_img {
      margin-right: 50px;
      display: flex;
      flex-direction: column;
      max-width: 400px;
      .image_title,
      .imageView {
        flex: 1;
      }
      .image_title {
        max-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .addNav_view_info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-radio {
        margin-right: 10px;
      }
      .addNav_view_btn {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .control_button {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .marketingWeb_top {
    width: 100%;
    max-height: 230px;
    flex: 1;
    .top_info {
      height: 180px;
      width: 100%;
      display: flex;
    }
    .top_control {
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
    .el-image {
      flex: 1;
      max-width: 200px;
      display: flex;
      align-items: center;
      img {
        height: auto;
      }
    }
    .marketingWeb_top_info {
      flex: 1;
      margin-left: 20px;
      .margin-top {
        .el-tag {
          margin-right: 5px;
        }
      }
    }
  }
  .marketingWeb_bottom {
    flex: 1;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .el-tabs {
      flex: 1;
      max-height: 50px;
    }
    .el-tabs__item {
      font-weight: 700;
      letter-spacing: 1px;
    }
  }
  .marketingWeb_bottom_main {
    width: 100%;
    height: 0;
    flex: 1;
    background-color: #fff;
    padding: 0 10px;
    border-radius: 4px;
    overflow: hidden;
    .aboutUsSynopsis_view {
      width: 100%;
      min-height: 300px;
      font-size: 16px;
      margin-top: 20px;
      .aboutUsSynopsis_view_text {
        width: 1000px;
        margin: 0 auto;
        text-indent: 2em;
      }
      .aboutUsSynopsis_view_btn {
        display: flex;
        margin-top: 20px;
        justify-content: center;
      }
    }
    .product_column_view,
    .information_column_view,
    .aboutUs_column_view {
      display: flex;
      flex-direction: column;
      height: 100%;
      .column_btn {
        min-height: 100px;
        max-height: 100px;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
      }
      .column_btn,
      .column_view {
        flex: 1;
      }
    }

    .product_column_view {
      .column_view {
        .adImage_view {
          width: 100%;
          height: 400px;
          display: flex;
          justify-content: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .productArticles_list {
          width: 100%;
          min-height: 400px;
          display: flex;
          flex-direction: column;
        }
      }
    }
    .information_view {
      width: 100%;
      min-height: 400px;

      .information_view_main {
        margin-bottom: 20px;
      }
    }
    .qaData_view {
      width: 100%;
      .qaData_view_top {
        display: flex;
        justify-content: flex-end;
      }
      .qaData_view_bottom {
      }
    }
    .homePageHeadline_view {
      width: 100%;
      min-height: 400px;
      .view_top {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
    .publicity_text_view {
      width: 100%;
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .publicity_text_view_top {
        width: 100%;
        .top_btn {
          width: 100%;
          display: flex;
          justify-content: center;
        }
        .top_info {
          width: 100%;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1.3em;
          .publicity_text_title {
            font-size: 40px;
            font-weight: 700;
          }
          .publicity_text_describe {
            font-weight: 700;
            width: 150px;
            margin-left: 20px;
            font-size: 17px;
          }
        }
      }
      .publicity_text_view_bottom {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
    .product_list {
      width: 100%;
      min-height: 500px;
      padding: 0 10px;
      box-sizing: border-box;
      overflow: auto;
      .product_list_btn {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
    .carousel_view {
      width: 600px;
      height: 200px;
      margin: 0 auto;
      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .reference_view {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .reference_view_title {
        color: #999;
      }
    }
    .card_view {
      width: 100%;
      height: 200px;
      box-sizing: border-box;
      padding: 0 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .card_view_title {
        width: 530px;
        box-sizing: border-box;
        padding: 0 20px;
        font-weight: 700;

        .title_top {
          font-size: 18px;
        }
        .title_bottom {
          margin-top: 20px;
        }
      }
    }
    .mode_nonactivated {
      width: 100%;
      cursor: pointer;
      // height: 200px;
      // background-color: pink;
    }
  }
}
</style>